import { create } from 'zustand';

export const homeStore = create((set) => ({
  categoryId: 0,
  tiendaId: 0,
  comunaId: 0,
  maquinaId: 0,
  setCategory: (id) => set({ categoryId: id }),
  setStore: (id) => set({ tiendaId: id }),
  setComuna: (id) => set({ comunaId: id }),
  setMaquina: (id) => set({ maquinaId: id }),
  clearAll: () => set({ 
    maquinaId: 0, 
    tiendaId: 0,
    comunaId: 0,
    categoryId: 0,
  }),
}))